<template>
  <div class="external-sign-files">
    <div
      class="table-scroll"
      style="--table-min-width: 640px"
      tabindex="0"
      role="region"
      :aria-label="$t('common.scrollableTable')"
    >
      <table class="w-full">
        <tr v-for="file in documentData.files" :key="file.fileGuid">
          <td>
            {{ file.fileName }}
          </td>
          <td>
            <button
              v-if="documentData.allowedActions.canView"
              class="w-5 text-primary-300 mx-1"
              :title="t('sign.actions.viewFile')"
              @click="viewFile(file)"
            >
              <EyeIcon />
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { EyeIcon } from "@heroicons/vue/outline";
import { baseSignApi } from "@/config/http-sign";
import { t } from "@/i18n";

export default {
  props: ["documentData"],
  components: {
    EyeIcon,
  },
  data: () => ({
    t,
  }),
  methods: {
    async viewFile(file) {
      try {
        const token = this.$route.params.token;

        const response = await baseSignApi.get(
          `/public/external-sign/${token}/files/${file.fileGuid}/view`,
          {
            responseType: "blob",
          }
        );

        let fileName = file.name || "document";

        const hasExtension = /\.[^/.]+$/.test(fileName);

        if (!hasExtension) {
          fileName += ".pdf";
        }

        const blob = new Blob([response.data], {
          type: "application/pdf",
        });

        const fileURL = window.URL.createObjectURL(blob);

        const newWindow = window.open(fileURL);

        if (newWindow) {
          newWindow.document.title = fileName;
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
td {
  padding: 5px 10px;
}
tr:nth-of-type(odd) {
  background: #e1e1e1;
}
tr:last-child {
  border-bottom: none;
}
tr {
  border-bottom: 1px solid #ddd;
}
</style>
